import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${barnesTheme.spacing.contentGap};
  margin-top: ${barnesTheme.spacing.contentGap};

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: ${barnesTheme.spacing.contentGap} !important;
    margin-top: ${barnesTheme.spacing.contentGap} !important;
  }
`

export const MapPlaceholder = styled.div`
  width: 100%;
  height: 170px;
  background: ${barnesTheme.colors.backgroundLight};
  position: relative;
  overflow: hidden;

  @media print {
    width: 100% !important;
    height: 170px !important;
    background: ${barnesTheme.colors.backgroundLight} !important;
    position: relative !important;
    overflow: hidden !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatsGrid = styled.div`
  display: flex;
  gap: ${barnesTheme.spacing.contentGap};

  @media print {
    display: flex !important;
    gap: ${barnesTheme.spacing.contentGap} !important;
  }
`

export const StatCard = styled.div<{ $wide?: boolean }>`
  flex: ${({ $wide }) => ($wide ? 1.8 : 1)};
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media print {
    flex: ${({ $wide }) => ($wide ? '1.8' : '1')} !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
`

export const StatValue = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: ${barnesTheme.fontSizes.large};
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  line-height: 1.2;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: ${barnesTheme.fontSizes.large} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    line-height: 1.2 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatLabel = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  margin-top: 2px;

  @media print {
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const Hairline = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};
  margin: ${barnesTheme.spacing.contentGap} 0;

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    margin: ${barnesTheme.spacing.contentGap} 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  margin-top: ${barnesTheme.spacing.contentGap};

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr !important;
    gap: 12px !important;
    margin-top: ${barnesTheme.spacing.contentGap} !important;
  }
`

export const ListingsGridOverflow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  margin-top: ${barnesTheme.spacing.contentGap};

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr !important;
    gap: 12px !important;
    margin-top: ${barnesTheme.spacing.contentGap} !important;
  }
`

export const ListingCard = styled.div`
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;

  @media print {
    width: 100% !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
  }
`

export const ListingImageArea = styled.div`
  width: 100%;
  height: 100px;
  background: ${barnesTheme.colors.backgroundLight};
  position: relative;
  overflow: hidden;
  cursor: pointer;

  @media print {
    width: 100% !important;
    height: 100px !important;
    background: ${barnesTheme.colors.backgroundLight} !important;
    position: relative !important;
    overflow: hidden !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media print {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
  }
`

export const ListingNumber = styled.div`
  position: absolute;
  bottom: 6px;
  left: 6px;
  width: 20px;
  height: 20px;
  background: ${barnesTheme.colors.primary};
  color: ${barnesTheme.colors.white};
  font-family: ${barnesTheme.fonts.body};
  font-size: 9px;
  font-weight: ${barnesTheme.fontWeights.bold};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  @media print {
    position: absolute !important;
    bottom: 6px !important;
    left: 6px !important;
    width: 20px !important;
    height: 20px !important;
    background: ${barnesTheme.colors.primary} !important;
    color: ${barnesTheme.colors.white} !important;
    font-size: 9px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 50% !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatusBadge = styled.div<{ $active?: boolean }>`
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 2px 8px;
  font-family: ${barnesTheme.fonts.body};
  font-size: 7px;
  font-weight: ${barnesTheme.fontWeights.bold};
  background: ${barnesTheme.colors.primary};
  color: ${barnesTheme.colors.white};

  @media print {
    position: absolute !important;
    top: 6px !important;
    right: 6px !important;
    padding: 2px 8px !important;
    font-size: 7px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    background: ${barnesTheme.colors.primary} !important;
    color: ${barnesTheme.colors.white} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingInfo = styled.div`
  padding: 8px 0;

  @media print {
    padding: 8px 0 !important;
  }
`

export const ListingPropertyType = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.accent};

  @media print {
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.accent} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingCity = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 12px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  margin-top: 2px;

  @media print {
    font-size: 12px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    margin-top: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingAddress = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.text};
  margin-top: 2px;

  @media print {
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.text} !important;
    margin-top: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingSpecs = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    margin-top: 4px !important;
  }
`

export const SpecItem = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};

  svg {
    flex-shrink: 0;
  }

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 3px !important;
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    svg {
      flex-shrink: 0 !important;
    }
  }
`

export const ListingPrice = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 11px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  margin-top: 4px;

  @media print {
    font-size: 11px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    margin-top: 4px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingPricePerSqm = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 7px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  margin-top: 1px;

  @media print {
    font-size: 7px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 1px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* Legacy exports kept for backward compatibility */
export const ListingIconsRow = styled.div`
  display: none;
`

export const IconItem = styled.div`
  display: none;
`

export const ListingFooterText = styled.div`
  display: none;
`
